var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.1,199l-14.5-14.5c-0.8-0.8-1.3-2-1.3-3.1v-49.8c0-36.5-16.8-78.8-54-95.4c-2.8-16.9-16.7-30.1-33.7-31.1 c-10.2-0.8-20.1,2.6-27.8,9.9c-6,5.6-9.9,13.2-11.2,21.3c-37.2,16.6-53.9,58.9-53.9,95.4v49.8c0,1.1-0.5,2.3-1.3,3.1L43.9,199 c-5.2,5.2-8,12.1-8,19.4c0,15.1,12.3,27.4,27.4,27.4h30.7c3.8,27.7,27.3,49.2,56.1,49.2s52.3-21.5,56.1-49.2h30.6 c15.1,0,27.4-12.3,27.4-27.4C264.1,211,261.3,204.2,256.1,199z M150,271.4c-15.7,0-28.8-11-32.2-25.6h64.5 C178.8,260.4,165.7,271.4,150,271.4z M236.7,222.1H63.3c-2,0-3.7-1.7-3.7-3.7c0-1,0.4-1.9,1.1-2.6l14.5-14.5 c5.2-5.2,8.2-12.5,8.2-19.8v-49.8c0-29.4,14.2-65.7,45.4-75.9l8.1-2.7V41.8c0-3.6,1.5-7.1,4.1-9.6c1.8-1.7,4.7-3.6,8.7-3.6 c0.4,0,0.7,0,1.1,0c6.9,0.4,12.3,6.5,12.3,13.7v10.7l8.1,2.7c31.2,10.2,45.4,46.5,45.4,75.9v49.8c0,7.4,3,14.6,8.2,19.8l14.5,14.5 l0,0c0.7,0.7,1.1,1.6,1.1,2.6C240.5,220.4,238.8,222.1,236.7,222.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarma);
export default __webpack_public_path__ + "static/media/alarma.607334da7fb638d0a7c7b05ccd58b95e.svg";
export { ForwardRef as ReactComponent };